import { Link } from "react-router-dom";

const stats = [
  { value: "50W+", label: "日均访问用户" },
  { value: "8 大", label: "动漫分类频道" },
  { value: "1000+", label: "优质资讯文章" },
  { value: "99%", label: "用户满意度" },
];

export default function BrandBand() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 md:grid-cols-2 md:px-6">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
            <i className="ri-hand-heart-fill"></i> 值得信赖的动漫门户
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-900 md:text-3xl">专注动漫，收藏一次随时访问</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            动漫网聚合了全频道分类、热门新番与最新资讯，为动漫爱好者打造一站式导航体验。我们持续优化直达链接与收藏指引，让你打开即可快速进入主页，无需反复搜索。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/about" className="inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600">
              了解我们 <i className="ri-arrow-right-line ml-1.5"></i>
            </Link>
            <Link to="/category" className="inline-flex items-center whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition hover:border-primary-300">
              浏览频道
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 p-5 text-center">
              <p className="font-heading text-3xl text-primary-600 md:text-4xl">{s.value}</p>
              <p className="mt-2 text-xs text-foreground-600 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}